<template>
  <b-card>

    <div class="loading_page" v-if="requestStatus">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
    </div>

    <b-tabs vertical content-class="col-12 col-md-9 mt-1 mt-md-0"
      nav-wrapper-class="col-md-2 col-12 border rounded p-1" nav-class="nav-left" pills>

      <info-tab :errors="errors" :driver-data="driverData" @onSubmit="submit" class="mt-2 pt-75" />

    </b-tabs>
  </b-card>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import driverStoreModule from '@/views/modules/driver/driverStoreModule'

import { OrbitSpinner } from 'epic-spinners'
import InfoTab from '@/views/modules/driver/tabs/InfoTab'
import Ripple from 'vue-ripple-directive'
export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BButton,
    BAlert,
    OrbitSpinner,
    InfoTab,
    BLink,
  },
  directives: {
    Ripple,
  },
  setup(props, { root }) {

    const driverData = ref({})

    const errors = ref({})

    const requestStatus = ref(false)

    const DRIVER_APP_STORE_MODULE_NAME = 'app_driver'

    if (!store.hasModule(DRIVER_APP_STORE_MODULE_NAME)) store.registerModule(DRIVER_APP_STORE_MODULE_NAME, driverStoreModule)

    onUnmounted(() => {
      if (store.hasModule(DRIVER_APP_STORE_MODULE_NAME)) store.unregisterModule(DRIVER_APP_STORE_MODULE_NAME)
    })

    const submit = () => {
      requestStatus.value = true
      errors.value = {}
      store.dispatch('app_driver/addDriver', driverData.value).then(res => {
        requestStatus.value = false
        toaster('Driver Created successfully', 'success', 'success')
        router.replace({name: 'drivers.edit', params:{id:res.data.driver.id}})
      }).catch(res => {
        errors.value = res.response.data.errors
      }).finally(() => {
        requestStatus.value = false
      })
    }

    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    return {
      driverData,
      requestStatus,
      errors,
      submit
    }
  },
}
</script>

<style></style>
